/**
 * SALUS scent quiz UX helper — DEV theme 189770006806 only.
 *
 * 2026-09-09 owner visual FAIL fix:
 * - Override RH quiz customCSS negative margins (margin-top:-80px) that clip titles
 * - Center picture-choice thumbnails; clear cream image-wrapper backgrounds
 * - Preserve bounce fix: NO setInterval scroll loops / NO scrollIntoView loops
 * - Fresh-state for quiz_T5o4Vv only (RH storage keys)
 * t1119: larger question-text instructions; kill RH enter/opacity/height reveal delays
 * t1120: one-shot instant land at new question heading (page + internal scroll); no smooth/loop
 */
(function () {
  'use strict';

  var QUIZ_ID = 'T5o4Vv';
  var QUIZ_TARGET = 'quiz_T5o4Vv';
  var SOFT_RESET_KEY = 'salus_scent_quiz_soft_reset_v1';
  var STYLE_ID = 'salus-scent-quiz-nav-style';
  var HOST_STYLE_ID = 'salus-scent-quiz-host-style';

  window.__salusScentQuizNavInit = true;

  /* Shadow CSS — must beat RH design.customCSS !important rules */
  var CSS = [
    /* --- Title / question landing (undo RH -80px compression) --- */
    '.quiz .question-wrapper, .quiz div.question-wrapper{',
    '  margin-top:0 !important;',
    '  margin-bottom:0 !important;',
    '  padding-top:1rem !important;',
    '  padding-bottom:2.5rem !important;',
    '}',
    '.quiz .question{',
    '  margin-top:0 !important;',
    '  margin-bottom:0 !important;',
    '  padding-top:0.75rem !important;',
    '  padding-bottom:0.5rem !important;',
    '  overflow:visible !important;',
    '}',
    '.quiz .question-content{',
    '  margin-top:0 !important;',
    '  margin-bottom:0 !important;',
    '  padding-top:0.5rem !important;',
    '  padding-bottom:1rem !important;',
    '  overflow:visible !important;',
    '}',
    '.quiz .heading.question-heading,',
    '.quiz .question-heading,',
    '.quiz .question-title,',
    '.quiz h1.question-heading,',
    '.quiz .question h1,',
    '.quiz .question h2{',
    '  margin-top:0.25rem !important;',
    '  margin-bottom:0.5rem !important;',
    '  padding-top:0.25rem !important;',
    '  padding-left:0.75rem !important;',
    '  padding-right:0.75rem !important;',
    '  max-width:100% !important;',
    '  box-sizing:border-box !important;',
    '  overflow:visible !important;',
    '  white-space:normal !important;',
    '  overflow-wrap:anywhere !important;',
    '}',
    '.quiz .q-welcome .question-content{',
    '  margin-top:0 !important;',
    '  padding-top:0.5rem !important;',
    '}',
    '.quiz .question-block{',
    '  margin-top:0.35rem !important;',
    '  margin-bottom:0.5rem !important;',
    '}',

    /* Sticky Next — CSS only, no scroll fighting */
    '.quiz .navigation-bar{',
    '  position:sticky !important;',
    '  bottom:0 !important;',
    '  z-index:30 !important;',
    '  margin-top:0.5rem !important;',
    '  padding-top:0.35rem !important;',
    '  padding-bottom:max(0.5rem, env(safe-area-inset-bottom)) !important;',
    '  background:var(--quiz-background-color,#fff) !important;',
    '  box-shadow:0 -4px 14px rgba(0,0,0,.08) !important;',
    '}',
    '.quiz .navigation-bar__container{ padding-top:0.25rem !important; padding-bottom:0.35rem !important; }',
    '.quiz .question-button__container{',
    '  position:static !important;',
    '  margin-top:0.35rem !important;',
    '  margin-bottom:0.25rem !important;',
    '}',

    /* No transform transitions (bounce amplifier) */
    '.quiz .question, .quiz .question-choice__label{',
    '  transition:none !important;',
    '  transform:none !important;',
    '}',

    /* t1120b: flow-layout active question — RH absolute+translate(-50%,-50%) + height:auto
       collapsed the host to ~148px (matrix -600,-74) and clipped cards. */
    '.quiz, .quiz .question-preview, .quiz .question-wrapper, .quiz .question{',
    '  scroll-behavior:auto !important;',
    '}',
    '.quiz .question-wrapper, .quiz div.question-wrapper{',
    '  position:relative !important;',
    '  height:auto !important;',
    '  min-height:0 !important;',
    '  max-height:none !important;',
    '  overflow:visible !important;',
    '  transition:none !important;',
    '  animation:none !important;',
    '}',
    '.quiz .question-preview{',
    '  position:relative !important;',
    '  height:auto !important;',
    '  min-height:0 !important;',
    '  overflow:visible !important;',
    '}',
    /* Active question in normal flow so wrapper gets real height; no slide/fade */
    '.quiz .question-navigation-item{',
    '  position:absolute !important;',
    '  left:0 !important;',
    '  top:0 !important;',
    '  right:0 !important;',
    '  width:100% !important;',
    '  height:auto !important;',
    '  transform:none !important;',
    '  transition:none !important;',
    '  animation:none !important;',
    '  animation-duration:0s !important;',
    '  overflow:visible !important;',
    '  opacity:0 !important;',
    '  visibility:hidden !important;',
    '  pointer-events:none !important;',
    '  z-index:0 !important;',
    '}',
    '.quiz .question-navigation-item.enter,',
    '.quiz .question-navigation-item[data-visible="true"]{',
    '  position:relative !important;',
    '  left:auto !important;',
    '  top:auto !important;',
    '  right:auto !important;',
    '  width:100% !important;',
    '  height:auto !important;',
    '  transform:none !important;',
    '  opacity:1 !important;',
    '  visibility:visible !important;',
    '  pointer-events:auto !important;',
    '  z-index:2 !important;',
    '  animation:none !important;',
    '  animation-name:none !important;',
    '  transition:none !important;',
    '  overflow:visible !important;',
    '}',
    '.quiz .question-navigation-item.exit{',
    '  position:absolute !important;',
    '  opacity:0 !important;',
    '  visibility:hidden !important;',
    '  pointer-events:none !important;',
    '  z-index:0 !important;',
    '  animation:none !important;',
    '  transition:none !important;',
    '  transform:none !important;',
    '  height:0 !important;',
    '  overflow:hidden !important;',
    '}',
    '.quiz .vertical-forward.enter,',
    '.quiz .vertical-forward.exit,',
    '.quiz .vertical-backward.enter,',
    '.quiz .vertical-backward.exit,',
    '.quiz .horizontal-forward.enter,',
    '.quiz .horizontal-forward.exit,',
    '.quiz .horizontal-backward.enter,',
    '.quiz .horizontal-backward.exit{',
    '  animation:none !important;',
    '  animation-name:none !important;',
    '  animation-duration:0s !important;',
    '  transition:none !important;',
    '}',
    '.quiz .question-choice_list,',
    '.quiz .question-choice_list--picture-choice,',
    '.quiz .question-choice-item,',
    '.quiz .question-choice__label,',
    '.quiz .question-choice__label-thumbnail,',
    '.quiz .question-choice__label-thumbnail img,',
    '.quiz .question-block,',
    '.quiz .question-content,',
    '.quiz .question-text,',
    '.quiz .text.question-text{',
    '  animation:none !important;',
    '  transition:none !important;',
    '  opacity:1 !important;',
    '}',

    /* t1119: subheading / question instructions (RH .question-text) */
    '.quiz .question-text,',
    '.quiz .text.question-text,',
    '.quiz [data-cy="question-text"],',
    '.quiz [aria-label="Question text"]{',
    '  font-size:18px !important;',
    '  line-height:1.35 !important;',
    '  margin-top:14px !important;',
    '  margin-bottom:22px !important;',
    '  padding-top:0 !important;',
    '  padding-bottom:0 !important;',
    '  max-width:100% !important;',
    '  box-sizing:border-box !important;',
    '  overflow:visible !important;',
    '  opacity:1 !important;',
    '}',
    '.quiz .question-text p,',
    '.quiz .text.question-text p,',
    '.quiz [data-cy="question-text"] p{',
    '  font-size:inherit !important;',
    '  line-height:inherit !important;',
    '  margin:0 !important;',
    '}',
    /* keep main heading visible; spacing owned by question-text margin-top */
    '.quiz .heading.question-heading,',
    '.quiz .question-heading{',
    '  margin-bottom:0 !important;',
    '}',
    '@media (max-width: 749px){',
    '  .quiz .question-text,',
    '  .quiz .text.question-text,',
    '  .quiz [data-cy="question-text"],',
    '  .quiz [aria-label="Question text"]{',
    '    font-size:16px !important;',
    '    margin-top:12px !important;',
    '    margin-bottom:20px !important;',
    '  }',
    '}',
    '.mobile .quiz .question-text,',
    '.quiz.mobile .question-text,',
    '.mobile .quiz .text.question-text,',
    '.quiz.mobile .text.question-text{',
    '  font-size:16px !important;',
    '  margin-top:12px !important;',
    '  margin-bottom:20px !important;',
    '}',

    /* t1120c: mobile cards wider in viewport — cut RH 32px side padding; target ~92% of list
       (~350/390 prior PASS). Measure vs choice-list, not raw viewport. */
    '@media (max-width: 749px){',
    '  .quiz .question-content,',
    '  .quiz .results-content{',
    '    padding-left:10px !important;',
    '    padding-right:10px !important;',
    '    margin-bottom:24px !important;',
    '  }',
    '  .quiz .heading.question-heading,',
    '  .quiz .question-heading,',
    '  .quiz .question-text,',
    '  .quiz .text.question-text{',
    '    padding-left:0.35rem !important;',
    '    padding-right:0.35rem !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    padding-left:0 !important;',
    '    padding-right:0 !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row .question-choice__label{',
    '    width:92% !important;',
    '    max-width:92% !important;',
    '    min-width:0 !important;',
    '  }',
    '}',
    '.mobile .quiz .question-content,',
    '.quiz.mobile .question-content{',
    '  padding-left:10px !important;',
    '  padding-right:10px !important;',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz.mobile .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label{',
    '  width:92% !important;',
    '  max-width:92% !important;',
    '}',

    /* t1119: restore mobile card ~88% of choice-list (t1118 measured ~63% regression) */
    '@media (max-width: 749px){',
    '  .quiz .question-choice_list--picture-choice,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row,',
    '  .quiz .question-choice_list.picture-choice__medium{',
    '    display:flex !important;',
    '  flex-direction:column !important;',
    '    grid-template-columns:none !important;',
    '    align-items:center !important;',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice > div,',
    '  .quiz .question-choice_list--picture-choice .question-choice-item{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    flex:0 0 auto !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row .question-choice__label{',
    '    width:88% !important;',
    '    max-width:88% !important;',
    '    min-width:0 !important;',
    '    margin-left:auto !important;',
    '    margin-right:auto !important;',
    '  }',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice,',
    '.quiz.mobile .question-choice_list--picture-choice{',
    '  display:flex !important;',
    '  flex-direction:column !important;',
    '  grid-template-columns:none !important;',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz.mobile .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label{',
    '  width:88% !important;',
    '  max-width:88% !important;',
    '}',

    /* t1119: reserve image box so layout exists before decode */
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail{',
    '  aspect-ratio:1 / 1 !important;',
    '  width:100% !important;',
    '  min-height:0 !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail img{',
    '  opacity:1 !important;',
    '  visibility:visible !important;',
    '}',

/* --- Picture choices: kill RH 200x200 box; tight compose; wide mobile; one checkbox --- */
/* Force one card per row; each card ~90% of QUIZ width (not half-grid) */
    '.quiz .question-choice_list--picture-choice,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '.quiz .question-choice_list--picture-choice.question-choice_list--two-per-row,',
    '.mobile .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row{',
    '  display:flex !important;',
    '  flex-direction:column !important;',
    '  flex-wrap:nowrap !important;',
    '  align-items:center !important;',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '}',
    '.quiz .question-choice_list--picture-choice > div,',
    '.quiz .question-choice_list--picture-choice .question-choice-item,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row > div{',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  flex:0 0 auto !important;',
    '  display:flex !important;',
    '  justify-content:center !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label{',
    '  width:88% !important;',
    '  max-width:88% !important;',
    '  min-width:0 !important;',
    '  box-sizing:border-box !important;',
    '}',
'.quiz .question-choice_list--picture-choice.picture-choice-6-choices,',
    '.quiz .question-choice_list--picture-choice.picture-choice-7-choices,',
    '.quiz .question-choice_list--picture-choice.picture-choice-8-choices,',
    '.quiz .question-choice_list--picture-choice.picture-choice-9-choices,',
    '.quiz .question-choice_list--picture-choice.picture-choice-10-choices,',
    '.quiz .question-choice_list--picture-choice[class*="picture-choice-"]{',
    '  max-width:100% !important;',
    '  width:100% !important;',
    '}',
    '.quiz .question-choice_list--picture-choice,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '.quiz .question-choice_list.picture-choice__medium{',
    '  display:flex !important;',
    '  flex-direction:column !important;',
    '  flex-wrap:nowrap !important;',
    '  align-items:center !important;',
    '  justify-content:flex-start !important;',
    '  gap:0.55rem !important;',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  box-sizing:border-box !important;',
    '}',
    '.quiz .question-choice_list--picture-choice > div{',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  display:flex !important;',
    '  justify-content:center !important;',
    '  box-sizing:border-box !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '  position:relative !important;',
    '  display:flex !important;',
    '  flex-direction:column !important;',
    '  align-items:center !important;',
    '  justify-content:flex-start !important;',
    '  text-align:center !important;',
    '  gap:0.35rem !important;',
    '  box-sizing:border-box !important;',
    '  width:88% !important;',
    '  max-width:88% !important;',
    '  min-width:0 !important;',
    '  min-height:0 !important;',
    '  height:auto !important;',
    '  margin:0 auto !important;',
    '  padding:0.55rem 0.85rem 0.65rem !important;',
    '  border-radius:12px !important;',
    '  border:1px solid rgba(213,205,192,0.7) !important;',
    '  background:rgba(247,241,232,0.55) !important;',
    '  box-shadow:0 1px 2px rgba(28,25,23,0.035) !important;',
    '  transition:none !important;',
    '  transform:none !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-selected,',
    '.quiz .question-choice_list--picture-choice .question-choice__label:has(input:checked){',
    '  border-color:#179095 !important;',
    '  background:rgba(231,244,244,0.72) !important;',
    '  box-shadow:0 0 0 1px rgba(23,144,149,0.22) !important;',
    '}',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label .question-choice__label-thumbnail,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail{',
    '  min-height:0 !important;',
    '  min-width:0 !important;',
    '  height:auto !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content{',
    '  order:1 !important;',
    '  display:flex !important;',
    '  flex-direction:row !important;',
    '  align-items:center !important;',
    '  justify-content:center !important;',
    '  gap:0 !important;',
    '  width:100% !important;',
    '  min-height:0 !important;',
    '  height:auto !important;',
    '  margin:0 !important;',
    '  padding:0.1rem 1.35rem 0 !important;',
    '  box-sizing:border-box !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content p{',
    '  max-width:100% !important;',
    '  width:100% !important;',
    '  margin:0 !important;',
    '  padding:0 !important;',
    '  text-align:center !important;',
    '  white-space:normal !important;',
    '  overflow:visible !important;',
    '  text-overflow:clip !important;',
    '  overflow-wrap:break-word !important;',
    '  word-break:normal !important;',
    '  line-height:1.3 !important;',
    '  font-size:0.95rem !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content input[type="checkbox"],',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content input[type="radio"]{',
    '  position:absolute !important;',
    '  top:0.5rem !important;',
    '  left:0.5rem !important;',
    '  margin:0 !important;',
    '  z-index:3 !important;',
    '  width:1.05rem !important;',
    '  height:1.05rem !important;',
    '  flex:none !important;',
    '  accent-color:#179095 !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail-contain{',
    '  order:2 !important;',
    '  display:flex !important;',
    '  align-items:center !important;',
    '  justify-content:center !important;',
    '  margin:0.1rem auto 0 !important;',
    '  padding:0 !important;',
    '  width:auto !important;',
    '  max-width:100% !important;',
    '  background:transparent !important;',
    '  background-color:transparent !important;',
    '  border:0 !important;',
    '  box-shadow:none !important;',
    '  flex:0 0 auto !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail::before,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail::after{',
    '  display:none !important;',
    '  content:none !important;',
    '}',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label img,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail img,',
    '.quiz .question-choice_list--picture-choice .question-choice__label img{',
    '  display:block !important;',
    '  margin:0 auto !important;',
    '  width:100% !important;',
    '  height:auto !important;',
    '  max-width:100% !important;',
    '  max-height:auto !important;',
    '  border-radius:8px !important;',
    '  aspect-ratio:1 / 1 !important;',
    '  object-fit:cover !important;',
    '  background:transparent !important;',
    '}',
'@media (min-width: 750px){',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:min(100%, 19rem) !important;',
    '    max-width:min(100%, 19rem) !important;',
    '  }',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice,',
    '.quiz.mobile .question-choice_list--picture-choice{',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '.quiz.mobile .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label{',
    '  width:88% !important;',
    '  max-width:88% !important;',
    '  min-width:0 !important;',
    '  min-height:0 !important;',
    '  height:auto !important;',
    '  padding:0.6rem 0.85rem 0.7rem !important;',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label-content p,',
    '.quiz.mobile .question-choice_list--picture-choice .question-choice__label-content p{',
    '  font-size:1.02rem !important;',
    '  line-height:1.35 !important;',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label img,',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label img,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label-thumbnail,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label-thumbnail img{',
    '  width:100% !important;',
    '  height:auto !important;',
    '  max-width:100% !important;',
    '  max-height:auto !important;',
    '  min-width:0 !important;',
    '  min-height:0 !important;',
    '}',
    '@media (max-width: 749px){',
    '  .quiz .question-choice_list--picture-choice,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:88% !important;',
    '    max-width:88% !important;',
    '    min-width:0 !important;',
    '    min-height:0 !important;',
    '    height:auto !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label-content p{',
    '    font-size:1.02rem !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label img,',
    '  .quiz .question-choice_list--picture-choice .question-choice__label img{',
    '    width:100% !important;',
    '    height:auto !important;',
    '    max-width:100% !important;',
    '    max-height:auto !important;',
    '  }',
    '}',
/* SALUS Blue selection chrome + dark ink labels (no orange/red) */
    '.quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content p{',
    '  color:#30364D !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-selected,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-selected .question-choice__label-content,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-selected .question-choice__label-content p,',
    '.quiz .question-choice_list--picture-choice .question-choice__label:has(input:checked),',
    '.quiz .question-choice_list--picture-choice .question-choice__label:has(input:checked) .question-choice__label-content,',
    '.quiz .question-choice_list--picture-choice .question-choice__label:has(input:checked) .question-choice__label-content p{',
    '  color:#30364D !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-selected,',
    '.quiz .question-choice_list--picture-choice .question-choice__label:has(input:checked){',
    '  border-color:#179095 !important;',
    '  background:rgba(23,144,149,0.10) !important;',
    '  box-shadow:0 0 0 1px rgba(23,144,149,0.28) !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content input[type="checkbox"],',
    '.quiz .question-choice_list--picture-choice .question-choice__label-content input[type="radio"]{',
    '  accent-color:#179095 !important;',
    '  width:1.1rem !important;',
    '  height:1.1rem !important;',
    '  filter:none !important;',
    '}',
    /* Native checkbox appearance override toward teal */
    '.quiz .question-choice_list--picture-choice .question-choice__label-content input[type="checkbox"]{',
    '  appearance:auto !important;',
    '  -webkit-appearance:checkbox !important;',
    '  accent-color:#179095 !important;',
    '}',
    /* Measured mobile: card 88% of full quiz choice list width */
    '@media (max-width: 749px){',
    '  .quiz .question-choice_list--picture-choice,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    display:flex !important;',
    '    flex-direction:column !important;',
    '    align-items:center !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice > div,',
    '  .quiz .question-choice_list--picture-choice .question-choice-item{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:88% !important;',
    '    max-width:88% !important;',
    '    min-width:0 !important;',
    '    margin-left:auto !important;',
    '    margin-right:auto !important;',
    '  }',
    '}',
    '.mobile .quiz .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '.quiz.mobile .question-choice_list--picture-choice .question-choice__label,',
    '.mobile .picture-choice__medium.question-choice_list--two-per-row .question-choice__label{',
    '  width:88% !important;',
    '  max-width:88% !important;',
    '}',
/* PHOTO TREATMENT t1117: full-area photos — no circular crop */
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail-contain,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label .question-choice__label-thumbnail{',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  min-width:0 !important;',
    '  min-height:0 !important;',
    '  height:auto !important;',
    '  border-radius:8px !important;',
    '  overflow:hidden !important;',
    '  background:transparent !important;',
    '  display:block !important;',
    '  margin:0.15rem 0 0 !important;',
    '}',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail img,',
    '.quiz .question-choice_list--picture-choice .question-choice__label-thumbnail-contain img,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label img,',
    '.quiz .question-choice_list--picture-choice .question-choice__label img{',
    '  display:block !important;',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  height:auto !important;',
    '  max-height:none !important;',
    '  aspect-ratio:1 / 1 !important;',
    '  object-fit:cover !important;',
    '  object-position:center !important;',
    '  border-radius:8px !important;',
    '  margin:0 !important;',
    '  background:transparent !important;',
    '}',
/* t1118 DESKTOP: four equal photo columns; compact intro (mobile unchanged) */
    '@media (min-width: 750px){',
    '  .quiz .question-choice_list--picture-choice,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium,',
    '  .quiz .question-choice_list--picture-choice.question-choice_list--two-per-row,',
    '  .quiz .question-choice_list.picture-choice__medium,',
    '  .quiz .question-choice_list--picture-choice[class*="picture-choice-"]{',
    '    display:grid !important;',
    '    grid-template-columns:repeat(4, minmax(0, 1fr)) !important;',
    '    gap:0.75rem 0.75rem !important;',
    '    align-items:stretch !important;',
    '    justify-content:center !important;',
    '    width:min(100%, 72rem) !important;',
    '    max-width:min(100%, 72rem) !important;',
    '    margin-left:auto !important;',
    '    margin-right:auto !important;',
    '    flex-direction:unset !important;',
    '    flex-wrap:unset !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice > div,',
    '  .quiz .question-choice_list--picture-choice .question-choice-item{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    min-width:0 !important;',
    '    display:flex !important;',
    '    justify-content:stretch !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    min-width:0 !important;',
    '    margin:0 !important;',
    '    height:100% !important;',
    '    min-height:0 !important;',
    '    box-sizing:border-box !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label-thumbnail,',
    '  .quiz .question-choice_list--picture-choice .question-choice__label-thumbnail img,',
    '  .quiz .question-choice_list--picture-choice .question-choice__label img{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '    aspect-ratio:1 / 1 !important;',
    '    object-fit:cover !important;',
    '    border-radius:8px !important;',
    '  }',
    '  /* Compact opening / question vertical chrome */',
    '  .quiz .question-wrapper, .quiz div.question-wrapper{',
    '    padding-top:40px !important;',
    '    padding-bottom:40px !important;',
    '    margin-top:0 !important;',
    '    margin-bottom:0 !important;',
    '    min-height:0 !important;',
    '  }',
    '  .quiz .question,',
    '  .quiz .question-content,',
    '  .quiz .q-welcome .question-content{',
    '    padding-top:0 !important;',
    '    padding-bottom:0 !important;',
    '    margin-top:0 !important;',
    '    margin-bottom:0 !important;',
    '    min-height:0 !important;',
    '  }',
    '  .quiz .heading.question-heading,',
    '  .quiz .question-heading,',
    '  .quiz .question-title,',
    '  .quiz h1.question-heading,',
    '  .quiz .question h1,',
    '  .quiz .question h2{',
    '    margin-top:0 !important;',
    '    margin-bottom:0.5rem !important;',
    '    padding-top:0 !important;',
    '  }',
    '  .quiz .question-block{',
    '    margin-top:0.35rem !important;',
    '    margin-bottom:0.5rem !important;',
    '  }',
    '  .quiz .q-welcome{',
    '    min-height:0 !important;',
    '    justify-content:flex-start !important;',
    '  }',
    '}',
    /* t1120d: explicitly beat RH picture-choice max-width:200px */
    '.quiz .question-choice_list--picture-choice .question-choice__label,',
    '.quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label,',
    '.quiz .question-choice_list--picture-choice.question-choice_list--two-per-row .question-choice__label{',
    '  max-width:none !important;',
    '}',
    '@media (max-width: 749px){',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:92% !important;',
    '    max-width:92% !important;',
    '    min-width:0 !important;',
    '  }',
    '}',
    '@media (min-width: 750px){',
    '  .quiz .question-choice_list--picture-choice{',
    '    display:grid !important;',
    '    grid-template-columns:repeat(4, minmax(0, 1fr)) !important;',
    '  }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label{',
    '    width:100% !important;',
    '    max-width:100% !important;',
    '  }',
    '}',
    /* t1120c final mobile width lock — must win cascade */
    '@media (max-width: 749px){',
    '  .quiz .question-content{ padding-left:10px !important; padding-right:10px !important; }',
    '  .quiz .question-choice_list--picture-choice .question-choice__label,',
    '  .quiz .question-choice_list--picture-choice.picture-choice__medium .question-choice__label{',
    '    width:92% !important;',
    '    max-width:92% !important;',
    '  }',
    '}',
    /* 2026-10-15 quiz update: selection-cap notice (fixed, no layout shift) */
    '.salus-cap-note{',
    '  display:block !important;',
    '  visibility:visible !important;',
    '  opacity:1 !important;',
    '  position:fixed !important;',
    '  left:50% !important;',
    '  bottom:92px !important;',
    '  transform:translateX(-50%) !important;',
    '  z-index:60 !important;',
    '  max-width:90% !important;',
    '  box-sizing:border-box !important;',
    '  background:#179095 !important;',
    '  color:#fff !important;',
    '  font-size:14px !important;',
    '  line-height:1.3 !important;',
    '  text-align:center !important;',
    '  padding:8px 14px !important;',
    '  border-radius:8px !important;',
    '  box-shadow:0 2px 10px rgba(0,0,0,.18) !important;',
    '  pointer-events:none !important;',
    '}',
].join('\n');

  var HOST_CSS = [
    'body.template-page-scent-quiz .site-header,',
    'body.template-page-scent-quiz header.site-header{',
    '  position:static !important;',
    '  top:auto !important;',
    '}',
    'body.template-page-scent-quiz .announcement,',
    'body.template-page-scent-quiz .announcement-bar{',
    '  position:static !important;',
    '}',
    'body.template-page-scent-quiz quiz-renderer,',
    'body.template-page-scent-quiz #shadow-quiz{',
    '  display:block !important;',
    '  width:100% !important;',
    '  max-width:100% !important;',
    '  margin-left:0 !important;',
    '  margin-right:0 !important;',
    '  box-sizing:border-box !important;',
    '  overflow-x:hidden !important;',
    '  min-height:0;',
    '  min-height:auto;',
    '}',
    /* measured offset for any future RH scrollIntoView — set by JS */
    'html{ scroll-padding-top:var(--salus-quiz-header-offset, 0px); scroll-behavior:auto !important; }',
    'body.template-page-scent-quiz, body.template-page-scent-quiz *{',
    '  scroll-behavior:auto !important;',
    '}',
    'body.template-page-scent-quiz quiz-renderer{',
    '  scroll-margin-top:var(--salus-quiz-header-offset, 0px);',
    '}',
    'body.template-page-scent-quiz #shadow-quiz,',
    'body.template-page-scent-quiz quiz-renderer{',
    '  min-height:0 !important;',
    '  height:auto !important;',
    '  max-height:none !important;',
    '  overflow:visible !important;',
    '}'
  ].join('\n');

  function injectHostStyle() {
    var el = document.getElementById(HOST_STYLE_ID);
    if (el) {
      if (el.textContent !== HOST_CSS) el.textContent = HOST_CSS;
      return;
    }
    var style = document.createElement('style');
    style.id = HOST_STYLE_ID;
    style.textContent = HOST_CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function measureHeaderOffset() {
    var y = 0;
    try {
      var ann = document.querySelector('.announcement, .announcement-bar, [class*="announcement"]');
      var header = document.querySelector('.site-header, header.site-header');
      if (ann) y = Math.max(y, ann.getBoundingClientRect().bottom);
      if (header) y = Math.max(y, header.getBoundingClientRect().bottom);
    } catch (e) {}
    var px = Math.max(0, Math.ceil(y)) + 16;
    try {
      document.documentElement.style.setProperty('--salus-quiz-header-offset', px + 'px');
    } catch (e2) {}
    return px;
  }

  function getShadow() {
    var host = document.querySelector('#shadow-quiz');
    if (host && host.shadowRoot) return host.shadowRoot;
    host = document.querySelector('quiz-renderer');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  var injectingStyle = false;
  function injectStyle(sr) {
    if (!sr || injectingStyle) return;
    injectingStyle = true;
    try {
      var existing = sr.getElementById(STYLE_ID);
      if (!existing) {
        existing = document.createElement('style');
        existing.id = STYLE_ID;
        sr.appendChild(existing);
      }
      if (existing.textContent !== CSS) existing.textContent = CSS;
      /* Always move to end so we beat RH customCSS after each paint */
      try { sr.appendChild(existing); } catch (e0) {}
      if (!sr.__salusStyleOrdered) {
        sr.__salusStyleOrdered = true;
        setTimeout(function () {
          try {
            var el = sr.getElementById(STYLE_ID);
            if (el) sr.appendChild(el);
          } catch (e) {}
        }, 50);
        setTimeout(function () {
          try {
            var el = sr.getElementById(STYLE_ID);
            if (el) sr.appendChild(el);
          } catch (e2) {}
        }, 400);
      }
    } finally {
      injectingStyle = false;
    }
  }

  /* One-shot per question: land at heading — instant, no smooth, no setInterval loops */
  var lastTitle = '';
  var landRaf = 0;
  function activeQuestionRoot(sr) {
    if (!sr) return null;
    return (
      sr.querySelector('.question-navigation-item.enter') ||
      sr.querySelector('.question-navigation-item[data-visible="true"]') ||
      sr.querySelector('.question-navigation-item:not(.exit)') ||
      sr
    );
  }
  function zeroScrollTree(root) {
    if (!root) return;
    try {
      var nodes = root.querySelectorAll(
        '.quiz, .question, .question-wrapper, .question-content, .question-body, .question-preview, .question-split, .content-split'
      );
      for (var i = 0; i < nodes.length; i++) {
        try {
          if (nodes[i].scrollTop) nodes[i].scrollTop = 0;
        } catch (e1) {}
      }
      try {
        if (root.scrollTop) root.scrollTop = 0;
      } catch (e2) {}
    } catch (e) {}
  }
  function instantPageLand(headingEl) {
    if (!headingEl) return;
    try {
      /* Disable smooth scroll CSS for this jump */
      var html = document.documentElement;
      var prevHtml = html.style.scrollBehavior;
      var prevBody = document.body ? document.body.style.scrollBehavior : '';
      html.style.scrollBehavior = 'auto';
      if (document.body) document.body.style.scrollBehavior = 'auto';

      var offset = 12;
      try {
        var v = getComputedStyle(html).getPropertyValue('--salus-quiz-header-offset').trim();
        if (v) offset = Math.max(0, parseInt(v, 10) || 0) + 8;
      } catch (e0) {}

      var rect = headingEl.getBoundingClientRect();
      var target = Math.max(0, window.scrollY + rect.top - offset);
      window.scrollTo(0, target);
      /* Also snap quiz host if page still leaves heading below fold */
      var host = document.querySelector('#shadow-quiz') || document.querySelector('quiz-renderer');
      if (host) {
        try { host.scrollTop = 0; } catch (e1) {}
      }

      html.style.scrollBehavior = prevHtml;
      if (document.body) document.body.style.scrollBehavior = prevBody;
    } catch (e) {}
  }
  function landAtNewQuestion(sr) {
    if (!sr) return;
    var root = activeQuestionRoot(sr);
    var titleEl =
      (root && root.querySelector('.question-heading h1, .question-heading h2, .question-heading h3, .heading.question-heading h1, .heading.question-heading h2, .question-heading, .question-title, .question h1, .question h2')) ||
      sr.querySelector('.question-navigation-item.enter .question-heading h1, .question-navigation-item.enter .question-heading h2, .question-navigation-item.enter .question-heading');
    var title = titleEl ? (titleEl.textContent || '').trim() : '';
    if (!title || title === lastTitle) return;
    lastTitle = title;

    zeroScrollTree(sr);
    if (sr.host) {
      try { if (sr.host.scrollTop) sr.host.scrollTop = 0; } catch (e0) {}
    }
    zeroScrollTree(root);

    function expandHostToActive() {
      try {
        var active = activeQuestionRoot(sr);
        var host = document.querySelector('#shadow-quiz') || document.querySelector('quiz-renderer');
        if (!active || !host) return;
        var h = Math.ceil(active.scrollHeight || active.getBoundingClientRect().height || 0);
        if (h > 120) {
          host.style.minHeight = h + 'px';
          host.style.height = 'auto';
          host.style.overflow = 'visible';
        }
        var wrap = sr.querySelector('.question-wrapper');
        if (wrap && h > 120) {
          wrap.style.minHeight = '0';
          wrap.style.height = 'auto';
          wrap.style.overflow = 'visible';
        }
      } catch (eExp) {}
    }

    /* Immediate + rAF + short follow-up after images/layout (no smooth scroll, no loops) */
    expandHostToActive();
    instantPageLand(titleEl);
    if (landRaf) cancelAnimationFrame(landRaf);
    landRaf = requestAnimationFrame(function () {
      landRaf = 0;
      expandHostToActive();
      zeroScrollTree(sr);
      zeroScrollTree(root);
      instantPageLand(titleEl);
      setTimeout(function () {
        expandHostToActive();
        instantPageLand(titleEl);
      }, 50);
    });
  }
  function resetQuestionScroll(sr) {
    landAtNewQuestion(sr);
  }

  /* ---------- Fresh-state ---------- */
  function isRhStorageKey(key) {
    if (!key) return false;
    return key === 'quizCache' || key.indexOf('revenuehunt-') === 0;
  }
  function clearRhProgressStorage() {
    try {
      var keys = [];
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (isRhStorageKey(k)) keys.push(k);
      }
      for (var j = 0; j < keys.length; j++) {
        try { localStorage.removeItem(keys[j]); } catch (e1) {}
      }
    } catch (e) {}
  }
  function clearQuizUrlState() {
    try {
      if (window.revenueHuntQuizUrl && typeof window.revenueHuntQuizUrl.clear === 'function') {
        window.revenueHuntQuizUrl.clear();
        return;
      }
    } catch (e) {}
    try {
      var url = new URL(window.location.href);
      var changed = false;
      if (/^#quiz(-[A-Za-z0-9]+)?$/.test(url.hash) || /^#response-[A-Za-z0-9]+$/.test(url.hash)) {
        url.hash = '';
        changed = true;
      }
      if (url.searchParams.has('response_id')) {
        url.searchParams.delete('response_id');
        changed = true;
      }
      if (changed) window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e2) {}
  }
  function callSupportedRetake() {
    try {
      if (window.prq && typeof window.prq.retakeQuiz === 'function') {
        window.prq.retakeQuiz();
        return 'prq.retakeQuiz';
      }
    } catch (e) {}
    return null;
  }
  function quizLooksPastWelcome(sr) {
    if (!sr) return false;
    try {
      if (sr.querySelector('.navigation-bar')) return true;
      if (sr.querySelectorAll('.question-choice__label').length) return true;
    } catch (e) {}
    return false;
  }
  function softReplaceOnce() {
    try {
      var mark = window.location.pathname + window.location.search;
      if (sessionStorage.getItem(SOFT_RESET_KEY) === mark) {
        sessionStorage.removeItem(SOFT_RESET_KEY);
        return false;
      }
      sessionStorage.setItem(SOFT_RESET_KEY, mark);
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('response_id');
      window.location.replace(url.pathname + url.search);
      return true;
    } catch (e) {
      return false;
    }
  }
  function ensureFreshQuiz(opts) {
    opts = opts || {};
    clearRhProgressStorage();
    clearQuizUrlState();
    var via = callSupportedRetake();
    if (via) return via;
    if (opts.fromBfCache) {
      softReplaceOnce();
      return 'bfcache-soft-replace';
    }
    if (opts.allowSoftReplace) {
      var sr = getShadow();
      if (quizLooksPastWelcome(sr) || /response_id=|#response-|#quiz-/.test(window.location.href)) {
        softReplaceOnce();
        return 'stale-soft-replace';
      }
    }
    return 'storage-cleared';
  }


  /* ------------------------------------------------------------------
   * 2026-10-15 quiz update (theme-side only; RevenueHunt Admin untouched)
   * A) Selection cap: enforce each multi-select question's configured
   *    maximum BEFORE the click reaches RevenueHunt, so an excess choice
   *    never enters saved state. Selected cards can always be clicked to
   *    deselect. Max is read from the published quiz definition that RH
   *    loads (window.quiz.currentPage block preferences.maxSelected);
   *    CAP_FALLBACK mirrors the published values if state is not readable.
   * B) Results guard: hide any card whose product page
   *    is not live (404 / draft), and keep each card photo equal to the
   *    product's live featured photo.
   * ------------------------------------------------------------------ */
  var CAP_FALLBACK = { 'qbc-3fb9817f': 3, 'qbc-49903ddc': 4, 'qbc-44f68e54': 3 };
  var NUMWORD = { 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six' };
  /* 2026-10-15 follow-up: Pink Passion (bombshell-fragrance-oil) and Emerald Brush were only held from photo replacement, not from recommendations, so they are no longer hidden. Add a handle here only to hide a live product from quiz results. */
  var HOLD_HANDLES = {};
  var capNoteTimer = 0;

  function capForList(listEl) {
    var id = listEl && listEl.id;
    var max = 0;
    try {
      var pg = window.quiz && window.quiz.currentPage;
      var blocks = (pg && pg.blocks) || [];
      for (var i = 0; i < blocks.length; i++) {
        var b = blocks[i];
        if (b && b.ref === id && b.preferences) {
          if (b.preferences.multipleSelection === true) {
            max = parseInt(b.preferences.maxSelected, 10) || 0;
          } else {
            return 0;
          }
        }
      }
    } catch (e) {}
    if (!max && id && CAP_FALLBACK[id]) max = CAP_FALLBACK[id];
    return max > 0 ? max : 0;
  }

  function savedRefsForList(listEl) {
    try {
      var a = window.quiz && window.quiz.answers && window.quiz.answers.byBlock && window.quiz.answers.byBlock[listEl.id];
      return (a && a.choicesRefs) ? a.choicesRefs : [];
    } catch (e) { return []; }
  }

  function showCapNote(sr, max) {
    try {
      var note = sr.querySelector('.salus-cap-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'salus-cap-note';
        note.setAttribute('role', 'status');
        note.setAttribute('aria-live', 'polite');
        sr.appendChild(note);
      }
      note.textContent = 'You can choose up to ' + (NUMWORD[max] || String(max)) + '. Tap a selected card to swap it.';
      note.style.display = '';
      if (capNoteTimer) clearTimeout(capNoteTimer);
      capNoteTimer = setTimeout(function () {
        try { if (note && note.parentNode) note.parentNode.removeChild(note); } catch (e2) {}
      }, 2600);
    } catch (e) {}
  }

  function onCapEvent(ev) {
    try {
      if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
      var path = ev.composedPath ? ev.composedPath() : [];
      var item = null;
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.getAttribute && n.getAttribute('data-cy') === 'question-choice-item') { item = n; break; }
      }
      if (!item) return;
      var list = item.closest ? item.closest('[data-cy="question-choice-list"]') : null;
      if (!list) return;
      var max = capForList(list);
      if (!max) return;
      var input = item.querySelector('input');
      var refs = savedRefsForList(list);
      var already = item.getAttribute('aria-selected') === 'true' || (input && refs.indexOf(input.id) !== -1);
      if (already) return; /* deselect is always allowed */
      var domCount = list.querySelectorAll('[data-cy="question-choice-item"][aria-selected="true"]').length;
      if (Math.max(domCount, refs.length) < max) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ev.stopPropagation();
      var root = list.getRootNode && list.getRootNode();
      showCapNote(root && root.querySelector ? root : document, max);
    } catch (e) {}
  }

  function installSelectionCap(sr) {
    if (!sr || sr.__salusCapInstalled) return;
    sr.__salusCapInstalled = true;
    sr.addEventListener('click', onCapEvent, true);
    sr.addEventListener('keydown', onCapEvent, true);
  }

  var productCheck = {}; /* handle -> {state:'pending'|'ok'|'gone', img:string} */
  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function fileOf(url) {
    return String(url || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/, '');
  }
  function applyProductCheck(card, handle) {
    var r = productCheck[handle];
    if (!r) return;
    if (r.state === 'gone') {
      card.style.display = 'none';
      card.setAttribute('data-salus-hidden', 'not-live');
    } else if (r.state === 'ok' && r.img) {
      var img = card.querySelector('img.slot-product__image');
      if (img && fileOf(img.src) !== fileOf(r.img)) {
        var u = r.img.indexOf('?') === -1 ? r.img + '?' : r.img + '&';
        img.src = u + 'width=428&height=428&crop=center';
        img.setAttribute('data-salus-photo', 'live');
      }
    }
  }
  function guardResults(sr) {
    if (!sr) return;
    var cards = sr.querySelectorAll('.results-slot');
    if (!cards.length) return;
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) continue;
      if (HOLD_HANDLES[handle]) {
        card.style.display = 'none';
        card.setAttribute('data-salus-hidden', 'hold');
        continue;
      }
      if (!productCheck[handle]) {
        productCheck[handle] = { state: 'pending' };
        (function (h) {
          try {
            fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
              .then(function (resp) {
                if (resp.status === 404 || resp.status === 410) { productCheck[h] = { state: 'gone' }; return null; }
                if (!resp.ok) { delete productCheck[h]; return null; }
                return resp.json();
              })
              .then(function (j) {
                if (j && j.handle) productCheck[h] = { state: 'ok', img: (j.featured_image || '') };
                setTimeout(tick, 0);
              })
              .catch(function () { delete productCheck[h]; });
          } catch (eF) { delete productCheck[h]; }
        })(handle);
      } else {
        applyProductCheck(card, handle);
      }
    }
    /* hide a whole results block (with its heading) when every card in it is hidden */
    var blocks = sr.querySelectorAll('.result-block__container');
    for (var j = 0; j < blocks.length; j++) {
      var slots = blocks[j].querySelectorAll('.results-slot');
      if (!slots.length) continue;
      var allHidden = true;
      for (var k = 0; k < slots.length; k++) {
        if (slots[k].style.display !== 'none' && !slots[k].getAttribute('data-salus-hidden')) { allHidden = false; break; }
        if (getComputedStyle(slots[k]).display !== 'none') { allHidden = false; break; }
      }
      blocks[j].style.display = allHidden ? 'none' : '';
    }
  }

  window.__salusScentQuizFresh = {
    clearRhProgressStorage: clearRhProgressStorage,
    ensureFreshQuiz: ensureFreshQuiz,
    measureHeaderOffset: measureHeaderOffset,
    quizId: QUIZ_ID,
    quizTarget: QUIZ_TARGET
  };

  injectHostStyle();
  measureHeaderOffset();
  ensureFreshQuiz({ allowSoftReplace: false });

  window.addEventListener('pageshow', function (ev) {
    if (ev && ev.persisted) {
      ensureFreshQuiz({ fromBfCache: true, allowSoftReplace: true });
      return;
    }
    try { sessionStorage.removeItem(SOFT_RESET_KEY); } catch (e) {}
  });
  window.addEventListener('popstate', function () {
    ensureFreshQuiz({ allowSoftReplace: true });
  });
  window.addEventListener('resize', function () { measureHeaderOffset(); }, { passive: true });

  var ticking = false;
  function tick() {
    if (ticking) return;
    ticking = true;
    try {
      injectHostStyle();
      measureHeaderOffset();
      var sr = getShadow();
      if (!sr) return;
      injectStyle(sr);
      installSelectionCap(sr);
      guardResults(sr);
      resetQuestionScroll(sr);
    } finally {
      ticking = false;
    }
  }

  function boot() {
    tick();
    var host = document.querySelector('#shadow-quiz') || document.querySelector('quiz-renderer');
    if (host && !host.__salusObs) {
      host.__salusObs = true;
      var debounce = null;
      var obs = new MutationObserver(function () {
        if (debounce) clearTimeout(debounce);
        debounce = setTimeout(tick, 50);
      });
      obs.observe(host, { subtree: true, childList: true, attributes: false });
      if (host.shadowRoot) {
        obs.observe(host.shadowRoot, { subtree: true, childList: true, attributes: false });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 200); });
  } else {
    setTimeout(boot, 200);
  }
  setTimeout(boot, 1200);
  setTimeout(boot, 3500);
})();
